module.exports = __webpack_public_path__ + "static/media/react-icon.ccc30f89.png";